module.exports = "https://web-assets.ifttt.com/packs/media/header/return_key_icon-c0b6a16e.svg";